// extracted by css-extract-rspack-plugin
export default {"wrapper":"ReferralBanner_wrapper__ldqiV","textWrapper":"ReferralBanner_textWrapper__V9xuw","cta":"ReferralBanner_cta__lt2Rb"};